import SetHost from './SetHost';

export default SetHost;
export * from './SetHost.type';
